import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ProfileWidget: WidgetRegistryEntry = {
  name: "Profile",
  configuration: () => import("./configuration").then((module) => module.ProfileWidgetConfiguration),
  component: () => import("./profile-widget.component").then((module) => module.ProfileWidgetComponent)
};
